/* Gleemium - mobile filter dropdown for collection pages.
   On phones the filter sidebar is folded into a single "Filter" button that sits
   next to Sort by and opens the same filters as a compact dropdown panel.
   Desktop keeps the normal sidebar. The filter form itself is unchanged. */
(function () {
  'use strict';
  var MQ = window.matchMedia('(max-width: 768px)');
  var ICON = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><line x1="4" y1="6" x2="20" y2="6"/><line x1="7" y1="12" x2="17" y2="12"/><line x1="10" y1="18" x2="14" y2="18"/></svg>';
  var CHEV = '<svg class="gfd-btn__chev" width="10" height="6" viewBox="0 0 10 6" aria-hidden="true"><path d="M1 1l4 4 4-4" stroke="currentColor" stroke-width="1.5" fill="none" stroke-linecap="round"/></svg>';

  function activeCount() {
    var n = 0, price = false;
    try {
      new URLSearchParams(location.search).forEach(function (v, k) {
        if (k.indexOf('filter.') !== 0 || v === '') return;
        if (k.indexOf('filter.v.price.') === 0) { price = true; return; }
        n++;
      });
    } catch (e) {}
    return n + (price ? 1 : 0);
  }

  function setup(root) {
    if (root.getAttribute('data-gfd') === '1') return;
    var side = root.querySelector('.ghc__sidebar');
    var bar = root.querySelector('.ghc__toolbar');
    if (!side || !bar || !side.querySelector('form')) return;
    root.setAttribute('data-gfd', '1');

    var uid = 'gfd-' + Math.random().toString(36).slice(2, 8);
    side.id = side.id || uid + '-panel';
    var home = document.createComment('gfd-home');
    side.parentNode.insertBefore(home, side);

    var count = activeCount();
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'gfd-btn';
    btn.setAttribute('aria-expanded', 'false');
    btn.setAttribute('aria-controls', side.id);
    btn.innerHTML = ICON + '<span>Filter</span>'
      + (count ? '<span class="gfd-btn__n" aria-label="' + count + ' active">' + count + '</span>' : '')
      + CHEV;
    if (count) btn.classList.add('has-active');
    bar.insertBefore(btn, bar.firstChild);

    function isOpen() { return side.classList.contains('is-open'); }
    function open() {
      side.classList.add('is-open');
      btn.setAttribute('aria-expanded', 'true');
      btn.classList.add('is-open');
    }
    function close() {
      side.classList.remove('is-open');
      btn.setAttribute('aria-expanded', 'false');
      btn.classList.remove('is-open');
    }
    btn.addEventListener('click', function () { isOpen() ? close() : open(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isOpen()) { close(); btn.focus(); }
    });
    document.addEventListener('click', function (e) {
      if (!isOpen() || !MQ.matches) return;
      if (side.contains(e.target) || btn.contains(e.target)) return;
      close();
    });

    function place() {
      if (MQ.matches) {
        if (side.previousElementSibling !== bar) bar.parentNode.insertBefore(side, bar.nextSibling);
      } else {
        close();
        if (home.nextSibling !== side) home.parentNode.insertBefore(side, home.nextSibling);
      }
    }
    place();
    if (MQ.addEventListener) MQ.addEventListener('change', place);
    else if (MQ.addListener) MQ.addListener(place);
  }

  /* Price boxes: show the price exactly as it is in the URL (the section prints it
     in cents, so re-applying a filter multiplied the max price by 100), and leave
     empty boxes out of the submitted URL. Desktop and mobile. */
  function fixPrice(root) {
    var params;
    try { params = new URLSearchParams(location.search); } catch (e) { return; }
    var inputs = root.querySelectorAll('input[name^="filter.v.price."]');
    for (var i = 0; i < inputs.length; i++) {
      var v = params.get(inputs[i].name);
      inputs[i].value = v === null ? '' : v;
    }
    var forms = root.querySelectorAll('.ghc__sidebar form');
    for (var j = 0; j < forms.length; j++) {
      forms[j].addEventListener('submit', function () {
        var els = this.querySelectorAll('input[name^="filter.v.price."]');
        for (var k = 0; k < els.length; k++) if (els[k].value === '') els[k].disabled = true;
      });
    }
    window.addEventListener('pageshow', function () {
      for (var m = 0; m < inputs.length; m++) inputs[m].disabled = false;
    });
  }

  function init() {
    var roots = document.querySelectorAll('.ghc');
    for (var r = 0; r < roots.length; r++) fixPrice(roots[r]);
    for (var i = 0; i < roots.length; i++) setup(roots[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
